import {
    ADD_MEMBER_PROMOTIONS,
    ADD_MEMBER_PROMOTIONS_ERROR,
    ADD_MEMBER_PROMOTIONS_NOT_ADDED,
    ADD_MEMBER_PROMOTIONS_SUCCESS,
} from "core-web/state/models/Basket/constants";

import { BASKET_PROMOTION_ITEM_DATA } from "theme/config/constants";
import { BasketEvents } from "core-web/libs/Events/constants";
import Cookies from "js-cookie";
import Events from "core-web/libs/Events";
import { acquireMutex } from "core-web/state";
import addMemberPromotionsEndpoint from "core-web/libs/GrebbCommerceAPI/promotions/addMemberPromotionsEndpoint";
import buildCartProductTree from "core-web/utils/buildCartProductTree";
import getBasketInfoFieldByCode from "core-web/state/models/Basket/utils/getBasketInfoFieldByCode.ts";
import getMemberPromotions from "core-web/state/models/User/dispatches/getMemberPromotions";
import store from "core-web/state/store";

export const addMemberPromotions = (promotionIds) => async (dispatch, getState) => {
    const basketId = getState().basket.basketId;
    const mutexLock = await acquireMutex("basket.getBasket");
    // const currentlyActiveMemberPromotions = getState().basket.activeMemberPromotions;

    dispatch({ type: ADD_MEMBER_PROMOTIONS });

    try {
        const promotionIdsToApply = Array.isArray(promotionIds) ? promotionIds : [promotionIds];

        const response = await addMemberPromotionsEndpoint(basketId, promotionIdsToApply);
        const status = await response.status();

        if (status === 404) {
            throw "Promotions were not found";
        }

        if (status !== 200) {
            throw "Could not add promotion";
        }

        const responseBody = await response.body();
        const { basket, payments } = responseBody.data;

        const basketItemsTree = buildCartProductTree(basket.items);
        const basketItemsCount = basketItemsTree.reduce((total, item) => total + (item.quantity || 0), 0);
        Cookies.set("basket_items_amount", basketItemsCount);
        Cookies.set("basket_unique_items_amount", basketItemsTree.length);

        const basketPromotionItemData = JSON.parse(
            getBasketInfoFieldByCode(BASKET_PROMOTION_ITEM_DATA, basket.info)?.value || "{}",
        );
        const activeMemberPromotions = Object.keys(basketPromotionItemData).reduce((promotions, partNo) => {
            const currentProductPromotions = basketPromotionItemData?.[partNo];

            if (!currentProductPromotions) {
                return promotions;
            }

            currentProductPromotions.forEach((appliedPromotion) => {
                const { id, discount_amount: discountAmount } = appliedPromotion;

                if (id === null) {
                    return promotions;
                }

                if (promotions.some((promotion) => promotion.id === id)) {
                    promotions = promotions.map((promotion) => {
                        if (promotion.id === id) {
                            return Object.assign(promotion, {
                                discountAmount: promotion.discountAmount + discountAmount,
                            });
                        }

                        return promotion;
                    });
                } else {
                    promotions.push({ id, discountAmount });
                }
            });

            return promotions;
        }, []);

        if (!activeMemberPromotions?.length) {
            getMemberPromotions();
        }

        const memberPromotionDiscountAmount = activeMemberPromotions.reduce(
            (discount, { discountAmount: promotionDiscountAmount }) => (discount += promotionDiscountAmount || 0),
            0,
        );

        const basketData = {
            items: basketItemsTree,
            summary: basket.format.summary || [],
            promotions: basket.applied_promotions,
            info: basket.info || [],
        };

        const activePromotionIds = JSON.parse(JSON.stringify(activeMemberPromotions)).map((promotion) => promotion.id);
        const addedPromotions = JSON.parse(JSON.stringify(promotionIdsToApply)).map((promotion) => ({
            id: promotion,
            hasAdded: activePromotionIds.includes(promotion),
        }));
        const couldAddPromotions = addedPromotions.some((promotion) => promotion.hasAdded);

        if (!couldAddPromotions) {
            dispatch({
                type: ADD_MEMBER_PROMOTIONS_NOT_ADDED,
                items: basketData.items,
                summary: basketData.summary,
                promotions: basketData.promotions,
                info: basketData.info,
                payments,
                promotionErrorIds: addedPromotions.reduce((current, promotion) => {
                    if (!promotion.hasAdded) {
                        current.push(promotion.id);
                    }

                    return current;
                }, []),
            });

            Events.trigger(BasketEvents.UPDATED);

            mutexLock();

            return basketData;
        }

        dispatch({
            type: ADD_MEMBER_PROMOTIONS_SUCCESS,
            items: basketData.items,
            summary: basketData.summary,
            promotions: basketData.promotions,
            info: basketData.info,
            activeMemberPromotions,
            memberPromotionDiscountAmount,
            payments,
        });

        Events.trigger(BasketEvents.UPDATED);

        mutexLock();

        return basketData;
    } catch (e) {
        dispatch({ type: ADD_MEMBER_PROMOTIONS_ERROR, promotionErrorIds: promotionIds });

        mutexLock();

        console.error(e);
        return null;
    }
};

export default (promotionIds) => store.dispatch(addMemberPromotions(promotionIds));
